import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Navegación interna del módulo Soporte IT.
 *
 * El prototipo usaba una pila de vistas en memoria (`nav.go/back/reset`).
 * Aquí la reimplementamos sobre react-router para que cada vista tenga su
 * propia URL (deep-link, back del navegador, refresh) sin tener que tocar
 * el cuerpo de las vistas: siguen llamando a `nav.go("ticket", { code })`.
 */
const PATHS = {
  dashboard: () => "/soporte",
  tickets: (p = {}) => `/soporte/tickets${p.preset ? `?preset=${p.preset}` : ""}`,
  crear: () => "/soporte/tickets/crear",
  ticket: (p = {}) => `/soporte/tickets/${p.code}`,
  inventario: () => "/soporte/inventario",
  activo: (p = {}) => `/soporte/inventario/${p.id}`,
  recursos: () => "/soporte/recursos",
  usuario: (p = {}) => `/soporte/usuarios/${p.id}`,
  conocimiento: () => "/soporte/conocimiento",
  reportes: () => "/soporte/reportes",
};

export function useSoporteNav() {
  const navigate = useNavigate();
  return useMemo(
    () => ({
      go: (name, params = {}) => navigate(PATHS[name] ? PATHS[name](params) : "/soporte"),
      back: () => navigate(-1),
      reset: (name, params = {}) => navigate(PATHS[name] ? PATHS[name](params) : "/soporte", { replace: true }),
    }),
    [navigate]
  );
}
